module.exports = __webpack_public_path__ + "assets/img/news (22).7418b837.png";